<template>
    <div class="mt-15 mb-3">
        <div
            class="d-flex justify-space-between py-2 px-6 pt-6 fl-sg-container fl-sg-highlight-bg fl-sg-highlight--text"
            v-if="selectedQuestion"
        >
            <v-card :elevation="this.elevation" class="pa-2 px-5 title-container d-flex flex-column justify-center primary">
                <span class="title">{{ this.title }}</span>
                <span class="subtitle">{{ this.subtitle }}</span>
            </v-card>
            <v-card
                :elevation="this.elevation"
                class="d-flex justify-center align-center restart-icon-container primary"
                @click="this.onRestartButtonPressed"
            >
                <v-icon color="fl-primary-text">{{ mdiRestart }}</v-icon>
            </v-card>
            <vue-horizontal style="width: 100%">
                <div
                    :key="question.id"
                    v-for="question in questions"
                    class="d-flex align-center flex-column justify-center header-item"
                    style="cursor: pointer"
                    @click="onSelectQuestion(question)"
                >
                    <img
                        v-if="question.headerIconUrl"
                        class="pa-1"
                        :alt="'header icon for' + question.displayName"
                        :src="question.headerIconUrl"
                        height="35"
                        width="35"
                    />
                    <div class="px-4 display-name fl-sg-highlight-text--text" :class="{ selected: selectedQuestion.id === question.id }">
                        <span>{{ question.displayName }}</span>
                    </div>
                </div>
            </vue-horizontal>
        </div>
        <v-progress-linear class="fl-sg-container pa-0" :value="isLoading ? 0 : progress" :indeterminate="isLoading" />
    </div>
</template>

<script lang="ts">
import { Vue } from 'vue-property-decorator';
import { ShoppingGuideQuestion } from '../definitions';
import { PropType } from 'vue';
import { mdiRestart } from '@mdi/js';
import VueHorizontal from 'vue-horizontal';

export default Vue.extend({
    name: 'ShoppingGuideHeader',
    components: {
        VueHorizontal,
    },
    data: () => ({
        mdiRestart,
    }),
    props: {
        questions: {
            type: Array as PropType<ShoppingGuideQuestion[]>,
            required: true,
        },
        selectedQuestion: {
            type: Object as PropType<ShoppingGuideQuestion>,
            default: null,
            required: false,
        },
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            default: null,
            required: false,
        },
        boxShadow: {
            type: Boolean,
            default: true,
            required: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onSelectQuestion(question: ShoppingGuideQuestion): void {
            this.$emit('selectedQuestionChanged', question);
        },
        onRestartButtonPressed(): void {
            this.$emit('restartButtonPressed');
        },
    },
    computed: {
        elevation(): number {
            if (this.boxShadow) {
                return 2;
            }

            return 0;
        },
        progress(): number {
            return this.selectedQuestion ? (100 * (this.questions.indexOf(this.selectedQuestion) + 1)) / this.questions.length : 0;
        },
    },
});
</script>

<style scoped lang="scss">
$sideSpacing: 20px;
$restartIconWidth: 35px;

.display-name {
    font-size: 14px;
    font-weight: 300;
}

.title-container {
    height: 75px;
    position: absolute;
    top: -55px;
    left: $sideSpacing;
    max-width: calc(100% - #{$restartIconWidth} - #{$sideSpacing} - #{$sideSpacing} - #{$sideSpacing});

    .title {
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 22px;
    }
    .subtitle {
        font-size: 14px;
        font-weight: 300;
    }
}

.selected {
    font-weight: bold;
}
.fl-sg-container::v-deep {
    height: 95px;
    position: relative;

    .v-hl-container {
        justify-content: space-between;

        > * {
            min-width: 100px;
            cursor: pointer;
        }
    }

    .v-hl-btn-prev {
        transform: translateX(-20%);
    }

    .v-hl-btn-next {
        transform: translateX(20%);
    }
}
.restart-icon-container {
    height: $restartIconWidth;
    width: $restartIconWidth;
    position: absolute;
    top: -17px;
    right: $sideSpacing;
    cursor: pointer;
}
</style>
